"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mintStateBeet = exports.MintState = exports.mintStateDiscriminator = void 0;
const web3 = __importStar(require("@solana/web3.js"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
exports.mintStateDiscriminator = [81, 17, 143, 120, 23, 57, 22, 117];
/**
 * Holds the data for the {@link MintState} Account and provides de/serialization
 * functionality for that data
 *
 * @category Accounts
 * @category generated
 */
class MintState {
    constructor(version, bump /* size: 1 */, mint, policy, lockedBy, lastApprovedAt, lastTransferredAt, transferredCount) {
        this.version = version;
        this.bump = bump;
        this.mint = mint;
        this.policy = policy;
        this.lockedBy = lockedBy;
        this.lastApprovedAt = lastApprovedAt;
        this.lastTransferredAt = lastTransferredAt;
        this.transferredCount = transferredCount;
    }
    /**
     * Creates a {@link MintState} instance from the provided args.
     */
    static fromArgs(args) {
        return new MintState(args.version, args.bump, args.mint, args.policy, args.lockedBy, args.lastApprovedAt, args.lastTransferredAt, args.transferredCount);
    }
    /**
     * Deserializes the {@link MintState} from the data of the provided {@link web3.AccountInfo}.
     * @returns a tuple of the account data and the offset up to which the buffer was read to obtain it.
     */
    static fromAccountInfo(accountInfo, offset = 0) {
        return MintState.deserialize(accountInfo.data, offset);
    }
    /**
     * Retrieves the account info from the provided address and deserializes
     * the {@link MintState} from its data.
     *
     * @throws Error if no account info is found at the address or if deserialization fails
     */
    static async fromAccountAddress(connection, address) {
        const accountInfo = await connection.getAccountInfo(address);
        if (accountInfo == null) {
            throw new Error(`Unable to find MintState account at ${address}`);
        }
        return MintState.fromAccountInfo(accountInfo, 0)[0];
    }
    /**
     * Provides a {@link web3.Connection.getProgramAccounts} config builder,
     * to fetch accounts matching filters that can be specified via that builder.
     *
     * @param programId - the program that owns the accounts we are filtering
     */
    static gpaBuilder(programId = new web3.PublicKey('ocp4vWUzA2z2XMYJ3QhM9vWdyoyoQwAFJhRdVTbvo9E')) {
        return beetSolana.GpaBuilder.fromStruct(programId, exports.mintStateBeet);
    }
    /**
     * Deserializes the {@link MintState} from the provided data Buffer.
     * @returns a tuple of the account data and the offset up to which the buffer was read to obtain it.
     */
    static deserialize(buf, offset = 0) {
        return exports.mintStateBeet.deserialize(buf, offset);
    }
    /**
     * Serializes the {@link MintState} into a Buffer.
     * @returns a tuple of the created Buffer and the offset up to which the buffer was written to store it.
     */
    serialize() {
        return exports.mintStateBeet.serialize({
            accountDiscriminator: exports.mintStateDiscriminator,
            ...this,
        });
    }
    /**
     * Returns the byteSize of a {@link Buffer} holding the serialized data of
     * {@link MintState} for the provided args.
     *
     * @param args need to be provided since the byte size for this account
     * depends on them
     */
    static byteSize(args) {
        const instance = MintState.fromArgs(args);
        return exports.mintStateBeet.toFixedFromValue({
            accountDiscriminator: exports.mintStateDiscriminator,
            ...instance,
        }).byteSize;
    }
    /**
     * Fetches the minimum balance needed to exempt an account holding
     * {@link MintState} data from rent
     *
     * @param args need to be provided since the byte size for this account
     * depends on them
     * @param connection used to retrieve the rent exemption information
     */
    static async getMinimumBalanceForRentExemption(args, connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(MintState.byteSize(args), commitment);
    }
    /**
     * Returns a readable version of {@link MintState} properties
     * and can be used to convert to JSON and/or logging
     */
    pretty() {
        return {
            version: this.version,
            bump: this.bump,
            mint: this.mint.toBase58(),
            policy: this.policy.toBase58(),
            lockedBy: this.lockedBy,
            lastApprovedAt: (() => {
                const x = this.lastApprovedAt;
                if (typeof x.toNumber === 'function') {
                    try {
                        return x.toNumber();
                    }
                    catch (_) {
                        return x;
                    }
                }
                return x;
            })(),
            lastTransferredAt: (() => {
                const x = this.lastTransferredAt;
                if (typeof x.toNumber === 'function') {
                    try {
                        return x.toNumber();
                    }
                    catch (_) {
                        return x;
                    }
                }
                return x;
            })(),
            transferredCount: this.transferredCount,
        };
    }
}
exports.MintState = MintState;
/**
 * @category Accounts
 * @category generated
 */
exports.mintStateBeet = new beet.FixableBeetStruct([
    ['accountDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['version', beet.u8],
    ['bump', beet.uniformFixedSizeArray(beet.u8, 1)],
    ['mint', beetSolana.publicKey],
    ['policy', beetSolana.publicKey],
    ['lockedBy', beet.coption(beetSolana.publicKey)],
    ['lastApprovedAt', beet.i64],
    ['lastTransferredAt', beet.i64],
    ['transferredCount', beet.u32],
], MintState.fromArgs, 'MintState');
//# sourceMappingURL=data:application/json;base64,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